export const formatCurrency = (amount: string | number | undefined, currency: string = 'EUR'): string => {
    if (amount === null || amount === undefined || amount === '') return '';

    // Convert to number and check if it's valid
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(num)) return String(amount);

    // Format with thousand separator and 2 decimal places
    return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
};
